/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandMessenger = createReactComponent("brand-messenger", "IconBrandMessenger", [
  ["path", { d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1", key: "svg-0" }],
  ["path", { d: "M8 13l3 -2l2 2l3 -2", key: "svg-1" }]
]);

export { IconBrandMessenger as default };
//# sourceMappingURL=IconBrandMessenger.js.map
